import { allTrackers } from "app/services/track/track";

import { createManageIntegrationTrackingService } from "./factory";

const manageIntegrationTrackingService = createManageIntegrationTrackingService(
    allTrackers.dispatchTrackEvent.bind(allTrackers),
);

export default manageIntegrationTrackingService;
